import { format } from 'date-fns';

const PRINT_LOAD_TIMEOUT = 8000;
const PRINT_CLEANUP_TIMEOUT = 60000;
const DOWNLOAD_REVOKE_DELAY = 10000;
const VIEW_TAB_REVOKE_DELAY = 60000;

const buildFileName = (title) => {
  const safeTitle = String(title || 'Export')
    .replace(/[/\\:*?"<>|]/g, '-')
    .trim();

  return `${safeTitle} - ${format(new Date(), 'yyyy-MM-dd HH-mm-ss')}.pdf`;
};

const downloadBlobUrl = (url, title) => {
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = buildFileName(title);
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
};

export const printBlob = (blob, title) => {
  const url = URL.createObjectURL(blob);

  const iframe = document.createElement('iframe');
  iframe.style.position = 'fixed';
  iframe.style.right = '0';
  iframe.style.bottom = '0';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = '0';
  iframe.style.visibility = 'hidden';

  let isSettled = false;
  let hasPrinted = false;

  const cleanup = () => {
    if (isSettled) return;
    isSettled = true;
    iframe.remove();
    URL.revokeObjectURL(url);
  };

  const fallbackToDownload = () => {
    if (isSettled || hasPrinted) return;
    isSettled = true;
    iframe.remove();
    downloadBlobUrl(url, title);
    setTimeout(() => URL.revokeObjectURL(url), DOWNLOAD_REVOKE_DELAY);
  };

  iframe.onload = () => {
    const printWindow = iframe.contentWindow;

    if (!printWindow) {
      fallbackToDownload();
      return;
    }

    hasPrinted = true;
    printWindow.focus();
    printWindow.onafterprint = cleanup;
    printWindow.print();

    setTimeout(cleanup, PRINT_CLEANUP_TIMEOUT);
  };

  iframe.onerror = fallbackToDownload;
  setTimeout(fallbackToDownload, PRINT_LOAD_TIMEOUT);

  iframe.src = url;
  document.body.appendChild(iframe);
};

export const deliverBlob = (blob, { title, viewTab }) => {
  const url = URL.createObjectURL(blob);

  if (viewTab) {
    viewTab.location.href = url;
    setTimeout(() => URL.revokeObjectURL(url), VIEW_TAB_REVOKE_DELAY);
    return;
  }

  downloadBlobUrl(url, title);
  setTimeout(() => URL.revokeObjectURL(url), DOWNLOAD_REVOKE_DELAY);
};
